/* eslint-disable no-underscore-dangle */

import Renderer from "./array-renderer";

const EventEmitter = require("events");

class ArrayComponent extends EventEmitter {
    constructor(value) {
        super();
        this._value = value;
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    _registerListeners() {}

    _unregisterListeners() {}

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        const prom = this._renderer._shutdown();
        this._renderer = undefined;
        return prom;
    }

    setValue() {
        this.emit("Update", this._value);
    }

    getValue() {
        return this._value;
    }
}

export default ArrayComponent;
